import isFilteredField from "views/logic/IsFilteredField";
const MessageFieldsFilter = {
  filterFields(fields) {
    const result = {};
    Object.keys(fields).forEach((field) => {
      if (!isFilteredField(field)) {
        result[field] = fields[field];
      }
    });
    return result;
  }
};
export default MessageFieldsFilter;
